/**
  * @typedef {Object} Action
  * @property {string} type - type of the action
  * @property {string} title - title of the action
  * @property {[string]} args - args of the action
  * @property {Boolean} closeOnClick - control if the notification should be closed after the action is performed
  * 
 */
import Core from 'hvx/modules/CoreModule';
import Map from 'hvx/modules/MapModule';
import ol from 'ol';

export const Actions = {
  log : (args) => {
    console.log(...args);
  },
  zoom_to_location : (args) => {
    const [lat, lng, zoom] = args.map((arg) => parseFloat(arg));
    const map = Map.getMap();
    const view = map.getView();
    
    // eslint-disable-next-line no-undef
    view.setCenter(ol.proj.transform([lat,lng], 'EPSG:4326', 'EPSG:3857'));
    view.setZoom(zoom);
  },
  open_panel : (args) => {
    const [panel] = args;
    Core.EventManager.fireEvent(`HVX.${panel}.Toggle.On`);
  },
  reconnect : () => {
    Core.EventManager.fireEvent('HVX.websocket.reconnect');
  },

  copy_text : (args) => {
    const [text] = args;
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Text copied to clipboard');
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  },

  open_url : (args) => {
    const [url] = args;
    window.open(url, '_blank');
  },

  // TODO: flash object on the page

  /**
   * 
   * @param {Object} args
   */
  confirm : (args) => {
    args.cb();
  },
  /**
   * 
   * @param {Object} args 
   */
  decline: (args) => {
    args.cb();
  }
}; 